import type { Path } from '@/types/global';
import type { FCRAWorker } from '@/types/turn-api';

export const path = (path: Path<FCRAWorker.Address>) => path;
